exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.tcf-fb-group-error{color:#dc3545;display:flex;align-items:center;justify-content:flex-start;margin-top:12px;line-height:14px}.tcf-fb-group-error *{color:#dc3545}.tcf-fb-group-error__icon{margin-right:8px}", ""]);

